module.exports = __webpack_public_path__ + "static/media/sound3.a399392f.mp3";